// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-chip.v-chip--outlined.chip-success[data-v-1e90ed3e] {\n  background-color: #e9ffec !important;\n}\n.v-chip.v-chip--outlined.chip-error[data-v-1e90ed3e] {\n  background-color: #feeae6 !important;\n}\n.v-chip.v-chip--outlined.chip-warning[data-v-1e90ed3e] {\n  background-color: #FFF4DE !important;\n}", ""]);
// Exports
module.exports = exports;
